import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { AI_COMPANION } = ANALYTICS_CATEGORIES;
const { LOAD } = SNOWPLOW_EVENTS;

export const triggerAiCompanionHistoryLoadedEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: AI_COMPANION,
		name: 'dlr_ai_companion_history_loaded',
		schemaName: LOAD.SCHEMA,
		version: LOAD.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
